import script from "./Modal.vue?vue&type=script&lang=tsx"
export * from "./Modal.vue?vue&type=script&lang=tsx"

import "./Modal.vue?vue&type=style&index=0&id=b256c352&lang=scss"
import "./Modal.vue?vue&type=style&index=1&id=b256c352&lang=scss&scoped=true"

import exportComponent from "/builds/dc/siemens.fm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b256c352"]])

export default __exports__